import React from 'react';
import PropTypes from 'prop-types';

import classnames from 'classnames';

import Button from '@component/form/element/button';

const WIZARD_BUTTON_TYPE_PREV = 'previous';
const WIZARD_BUTTON_TYPE_NEXT = 'next';

export default class Wizard extends React.Component {
  state = {
    currentStep: 0,
  };

  getSteps() {
    return React.Children.toArray(this.props.children).filter(
      (child) => !child.props.disabled
    );
  }

  renderButton(props, type) {
    if (!props) {
      return null;
    }

    const buttonProps = {
      text: props.text,
      onClick:
        props.onClick ||
        (type === WIZARD_BUTTON_TYPE_NEXT ? this.goNext : this.goBack),
      className: classnames(
        `wizard__navigation-button`,
        `wizard__navigation-button--${type}`,
        props.className
      ),
      active: !props.disabled,
    };

    return <Button {...buttonProps} />;
  }

  goBack = () => {
    const { currentStep } = this.state;
    if (currentStep > 0) {
      this.setState({ currentStep: currentStep - 1 });
    }
  };

  goNext = () => {
    const { currentStep } = this.state;
    const steps = this.getSteps();
    if (steps && currentStep < steps.length - 1) {
      this.setState({ currentStep: currentStep + 1 });
    }
  };

  render() {
    const { currentStep } = this.state;
    const steps = this.getSteps();
    const { prevButton, nextButton } = steps[currentStep].props;

    return (
      <div className="wizard">
        {steps[currentStep]}
        <div className="wizard__navigation">
          {this.renderButton(prevButton, WIZARD_BUTTON_TYPE_PREV)}
          {this.renderButton(nextButton, WIZARD_BUTTON_TYPE_NEXT)}
        </div>
      </div>
    );
  }
}

Wizard.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};
